import { Config } from './config';
import { PaymentModel } from './models/PaymentModel';
import { PaymentSessionManager } from './services/PaymentSessionManager';
import * as utils from './utils';
class PayUpSDK {
    constructor(options) {
        this.isInitialized = false;
        this.config = Config.getInstance();
        if (options) {
            if (options.apiBaseUrl) {
                this.config.updateConfig({ API_BASE_URL: options.apiBaseUrl });
            }
            if (options.messageOrigin) {
                this.config.updateConfig({ MESSAGE_ORIGIN: options.messageOrigin });
            }
            if (options.version) {
                this.config.updateConfig({ VERSION: options.version });
            }
        }
        this.sessionManager = new PaymentSessionManager();
    }
    async init() {
        if (this.isInitialized)
            return;
        const clientToken = utils.getClientToken();
        if (!clientToken) {
            console.warn('PayUp SDK: Client token not found. Please add data-client-token attribute to script tag.');
        }
        this.isInitialized = true;
        this.autoInitialize();
    }
    autoInitialize() {
        utils.setupSmoothScrolling();
    }
    createPayment() {
        return new PaymentModel();
    }
    getVersion() {
        return this.config.getVersion();
    }
    get PaymentModel() {
        return PaymentModel;
    }
    getSessionManager() {
        return this.sessionManager;
    }
    async initiatePurchase(products, metadata = {}) {
        const clientToken = utils.getClientToken();
        if (!clientToken) {
            console.error('PayUp SDK: Client token not found');
            alert('Payment system not configured properly. Please add data-client-token to script tag.');
            return;
        }
        if (!Array.isArray(products) || products.length === 0) {
            console.error('PayUp SDK: Products must be a non-empty array');
            alert('Invalid products array. Expected: [{ sku: "SKU", quantity: 1 }]');
            return;
        }
        for (const product of products) {
            if (!product.storeCode || typeof product.storeCode !== 'string') {
                console.error('PayUp SDK: Each product must have a valid storeCode');
                alert('Invalid product format. Each product must have a "storeCode" field.');
                return;
            }
            if (!product.quantity || typeof product.quantity !== 'number' || product.quantity <= 0) {
                console.error('PayUp SDK: Each product must have a valid quantity');
                alert('Invalid product quantity. Must be a positive number.');
                return;
            }
        }
        console.log('🛒 Initiating purchase with products:', products);
        try {
            console.log('🔑 Tokenizing...');
            const sdkToken = await utils.tokenize();
            const paymentData = {
                products: products,
                metadata: metadata,
                returnUrl: window.location.href
            };
            console.log('💳 Creating payment session...');
            await this.sessionManager.createSession(paymentData, sdkToken);
        }
        catch (error) {
            console.error('❌ Purchase initiation failed:', error);
            alert('Failed to initiate purchase: ' + error.message);
        }
    }
}
const sdkInstance = new PayUpSDK();
if (typeof window !== 'undefined') {
    window.showPricing = function () {
        const element = document.getElementById('pricing');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };
    window.initiatePurchase = function (products, metadata = {}) {
        sdkInstance.initiatePurchase(products, metadata);
    };
    window.PayUpSDK = sdkInstance;
}
sdkInstance.init();
export default sdkInstance;
export { PayUpSDK, PaymentModel };
